import React from "react";

import "./Table.scss";

import moment from "moment";

const formatValue = (value, key) => {
  const number = Number(value) || 0;

  if (key === "ctr" || key === "view_percent") {
    return `${number.toLocaleString("ru-RU", {
      maximumFractionDigits: 2
    })}%`;
  }

  if (key === "cpm") {
    return number.toLocaleString("ru-RU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  if (key === "income" || key === "profit") {
    return `${number.toLocaleString("ru-RU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })} ₽`;
  }

  return number.toLocaleString("ru-RU");
};

const formatDate = (date, groupBy) => {
  // По дням: 2026-08-27
  if (groupBy === "day") {
    return moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
  }

  // По неделям: 2026W35
  if (groupBy === "week") {
    const match = date.match(/^(\d{4})W(\d{2})$/);

    if (!match) {
      return date;
    }

    const year = Number(match[1]);
    const week = Number(match[2]);

    const start = moment()
      .isoWeekYear(year)
      .isoWeek(week)
      .startOf("isoWeek");

    const end = start.clone().endOf("isoWeek");

    // показывает начало недели - конец
    // return `${start.format("DD.MM")} - ${end.format("DD.MM.YYYY")}`;

    // показывает начало недели
    return start.format("DD.MM.YYYY");
  }

  // По месяцам: 2026-08
  if (groupBy === "month") {
    return moment(date, "YYYY-MM").format("MM.YYYY");
  }

  return date;
};

const Table = ({ data, groupBy }) => {
  if (!data) {
    return null;
  }

  const dates = Object.keys(data.data || {}).sort().reverse();

  return (
    <div className="stats-table-wrapper">
      <table className="stats-table">
        <thead>
          <tr>
            <th rowSpan="2">Дата</th>

            <th rowSpan="2">Загрузки</th>
            <th rowSpan="2">Видимость %</th>
            <th rowSpan="2">Показы</th>

            <th colSpan="3">Клики</th>

            <th rowSpan="2">CPM</th>
            <th rowSpan="2">CTR</th>
            {/* <th rowSpan="2">Доход</th> */}
            <th rowSpan="2">Прибыль</th>
            {/* <th rowSpan="2">Возвраты</th>             */}
          </tr>

          <tr>
            <th>Рекламные</th>
            <th>Обменные</th>
            <th>Органики</th>
          </tr>
        </thead>

        <tbody>
          <tr className="stats-table__total">
            <td>Всего</td>

            <td>{formatValue(data.total?.visits, "visits")}</td>
            <td>{formatValue(data.total?.view_percent, "view_percent")}</td>
            <td>{formatValue(data.total?.views, "views")}</td>

            <td>{formatValue(data.total?.ad_clicks, "ad_clicks")}</td>
            <td>{formatValue(data.total?.exchange_clicks, "exchange_clicks")}</td>
            <td>{formatValue(data.total?.organic_clicks, "organic_clicks")}</td>

            <td>{formatValue(data.total?.cpm, "cpm")}</td>
            <td>{formatValue(data.total?.ctr, "ctr")}</td>
            {/* <td>{formatValue(data.total?.income, "income")}</td> */}
            <td>{formatValue(data.total?.profit, "profit")}</td>
            {/* <td>{formatValue(data.total?.returned, "returned")}</td> */}
          </tr>

          {dates.map((date) => {
            const dayData = data.data[date];

            return (
              <tr key={date}>
                <td>{formatDate(date, groupBy)}</td>

                <td>{formatValue(dayData?.visits, "visits")}</td>
                <td>{formatValue(dayData?.view_percent, "view_percent")}</td>
                <td>{formatValue(dayData?.views, "views")}</td>

                <td>{formatValue(dayData?.ad_clicks, "ad_clicks")}</td>
                <td>{formatValue(dayData?.exchange_clicks, "exchange_clicks")}</td>
                <td>{formatValue(dayData?.organic_clicks, "organic_clicks")}</td>

                <td>{formatValue(dayData?.cpm, "cpm")}</td>
                <td>{formatValue(dayData?.ctr, "ctr")}</td>
                {/* <td>{formatValue(dayData?.income, "income")}</td> */}
                <td>{formatValue(dayData?.profit, "profit")}</td>
                {/* <td>{formatValue(dayData?.returned, "returned")}</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;